import React from "react";
import { StyleSheet, TextProps, View, ViewProps } from "react-native";
import { PdText } from "src/components/layout";
import { kStyleConst } from "src/kStyle";

export type tPdBadgeColorScheme = "green" | "yellow" | "pink" | "red" | "orange";

export type tPdBadgeProps = {
  colorScheme?: tPdBadgeColorScheme;
} & ViewProps;

const colors: { [key in tPdBadgeColorScheme]: { backgroundColor: string; markerColor: string } } = {
  green: { backgroundColor: "#DDF8DA", markerColor: "#93EB85" },
  yellow: { backgroundColor: "#FAF6D1", markerColor: "#F4E76A" },
  pink: { backgroundColor: "#FCEAF9", markerColor: "#F9BDEF" },
  red: { backgroundColor: "#FDDBDB", markerColor: "#FB8C8C" },
  orange: { backgroundColor: "#FCEBD1", markerColor: "#F9C06B" },
};

export const PdBadge: React.FC<tPdBadgeProps> = ({ colorScheme = "green", style, children, ...rest }) => {
  const { backgroundColor, markerColor } = colors[colorScheme];
  return (
    <View style={[styles.pdBadge, { backgroundColor }, style]} {...rest}>
      <View style={[styles.pdBadgeMarker, { backgroundColor: markerColor }]} />
      {children}
    </View>
  );
};

export const PdBadgeLabel: React.FC<TextProps> = ({ style, ...rest }) => {
  return <PdText variant="body-xs" style={[styles.pdBadgeLabel, style]} numberOfLines={1} {...rest} />;
};

const styles = StyleSheet.create({
  pdBadge: {
    alignItems: "center",
    borderRadius: 999,
    flexDirection: "row",
    height: 26,
    paddingHorizontal: kStyleConst.kSpacing * 2,
    paddingVertical: kStyleConst.kSpacing * 2,
  },
  pdBadgeLabel: {
    fontWeight: "400",
    textTransform: "uppercase",
  },
  pdBadgeMarker: {
    borderRadius: 999,
    height: 12,
    marginRight: kStyleConst.kSpacing * 2,
    width: 12,
  },
});
